// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","input":"Search_input__klILD","icon":"Search_icon__XMmYc","close":"Search_close__9IFb1","closeLine":"Search_closeLine__hBKSP"};